module.exports = __webpack_public_path__ + "media/concept_stage-e6b82c26844fddf90e2c284e74aff553.svg";